import React, { Fragment } from "react";
import {useQueryClient} from "react-query";
import {Button, Icon, Tooltip} from "@material-ui/core";
import { useFlightLoadWeight } from "../../../services/flights";
import {MaskedNumber} from "../../../controls";


const CargoGrossWeight = (props) => {
  const {tripLegUuid, eventBus, record, classes} = props;

  const queryClient = useQueryClient();
  const extraKeys = [tripLegUuid];
  const tripLegWeight = useFlightLoadWeight({queryClient, extraKeys});

  return (
    <Fragment>
      {tripLegWeight && Array.isArray(tripLegWeight.data) && tripLegWeight.data.length > 0 && tripLegWeight.data[0].grossWeight
        ?
          record
          ?
            <Tooltip
              title={
                <MaskedNumber
                  displayType="text"
                  decimalScale={0}
                  fixedDecimalScale={true}
                  style= {{width:"100%", fontSize: "12px", textAlign: "right"}}
                  value={tripLegWeight.data[0].grossWeight}
                  suffix=" kg from uploaded Deadload statement"
                />
              }
            >
              <Button onClick={()=>{eventBus.trigger("EditDeadLoad.open", record);}} size="small" >
                <MaskedNumber
                  displayType="text"
                  decimalScale={0}
                  fixedDecimalScale={true}
                  style= {{width:"100%", fontSize: "12px", textAlign: "right"}}
                  value={tripLegWeight.data[0].grossWeight}
                  suffix=" kg"
                />
              </Button>
            </Tooltip>
          :
            <MaskedNumber
              displayType="text"
              decimalScale={0}
              fixedDecimalScale={true}
              style= {{width:"100%", textAlign: "right"}}
              value={tripLegWeight.data[0].grossWeight}
              suffix=" kg"
            />
        :
          record && record.actualCargo
            ?
              <Tooltip
                title={
                  <MaskedNumber
                    displayType="text"
                    decimalScale={0}
                    fixedDecimalScale={true}
                    style= {{width:"100%", fontSize: "12px", textAlign: "right"}}
                    value={record.actualCargo}
                    suffix=" kg recorded as flight Actual Payload data"
                  />
                }
              >
                <Button onClick={()=>{eventBus.trigger("EditCargoDialog.open", record);}} size="small" >
                  <MaskedNumber
                    displayType="text"
                    decimalScale={0}
                    fixedDecimalScale={true}
                    style= {{width:"100%", fontSize: "12px", textAlign: "right"}}
                    value={record.actualCargo}
                    suffix=" kg"
                  />
                </Button>
              </Tooltip>
            :
              <></>
      }
    </Fragment>
  );
}

export default CargoGrossWeight;
